import { Typography, Grid, Card, CardContent, SxProps, Theme } from "@mui/material";
import { Psychology, Timeline, Business, Work, TrendingDown, AttachMoney, Update, Group } from "@mui/icons-material";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";

export const Challenges = () => {
  return (
    <SectionContainer sx={{ background: "#F8F9FA" }}>
      <SectionTitle>開発での課題</SectionTitle>
      <Grid container spacing={4} sx={gridSx}>
        <Grid item xs={12} md={6}>
          <Card sx={cardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h3" sx={cardTitleSx}>
                <Psychology sx={iconSx} />
                多様なスキルセットの必要性
              </Typography>
              <Typography variant="body1" sx={cardDescriptionSx}>
                システム開発では様々な専門知識を持つ人材が必要です。
                <br />
                一人ですべてをカバーすることは困難です。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={cardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h3" sx={cardTitleSx}>
                <Timeline sx={iconSx} />
                工程による必要スキルの変化
              </Typography>
              <Typography variant="body1" sx={cardDescriptionSx}>
                開発の各フェーズで必要とされる技術スキルは大きく変わります。
                <br />
                人材の固定配置では非効率になります。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Typography variant="h3" sx={subtitleSx}>
        優秀な人材を集める難しさと継続雇用の難しさ
      </Typography>
      <Grid container spacing={3} sx={gridSx}>
        <Grid item xs={12} md={4}>
          <Card sx={subCardSx}>
            <CardContent sx={subCardContentSx}>
              <Typography variant="h4" sx={subCardTitleSx}>
                <Business sx={subIconSx} />
                大手企業による囲い込み
              </Typography>
              <Typography variant="body2" sx={subCardDescriptionSx}>
                優秀なエンジニアは大手企業に正社員として雇用されています。中小企業では採用が困難です。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={subCardSx}>
            <CardContent sx={subCardContentSx}>
              <Typography variant="h4" sx={subCardTitleSx}>
                <Work sx={subIconSx} />
                フリーランスの継続雇用
              </Typography>
              <Typography variant="body2" sx={subCardDescriptionSx}>
                腕の良いフリーランスは一度契約すると長期間囲い込まれ、市場に出てきません。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={subCardSx}>
            <CardContent sx={subCardContentSx}>
              <Typography variant="h4" sx={subCardTitleSx}>
                <TrendingDown sx={subIconSx} />
                転職市場の限界
              </Typography>
              <Typography variant="body2" sx={subCardDescriptionSx}>
                本当に優秀な人材は転職市場に出る前に引き抜かれていきます。見つけるのが困難です。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={subCardSx}>
            <CardContent sx={subCardContentSx}>
              <Typography variant="h4" sx={subCardTitleSx}>
                <AttachMoney sx={subIconSx} />
                高額な人件費
              </Typography>
              <Typography variant="body2" sx={subCardDescriptionSx}>
                希少な優秀人材は相応の報酬を要求します。企業の予算との折り合いが難しいです。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={subCardSx}>
            <CardContent sx={subCardContentSx}>
              <Typography variant="h4" sx={subCardTitleSx}>
                <Update sx={subIconSx} />
                変化するスキル要件
              </Typography>
              <Typography variant="body2" sx={subCardDescriptionSx}>
                開発フェーズによって必要なスキルセットが変化します。すべての工程で全スキルを持つチームを維持するのは非効率です。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={subCardSx}>
            <CardContent sx={subCardContentSx}>
              <Typography variant="h4" sx={subCardTitleSx}>
                <Group sx={subIconSx} />
                チーム維持の難しさ
              </Typography>
              <Typography variant="body2" sx={subCardDescriptionSx}>
                チームメンバーの入れ替えが頻繁に発生すると管理コストが増加します。
                人の入れ替えが頻繁に発生すると入れ替えによる退職なども発生します。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

const subtitleSx: SxProps<Theme> = (theme) => ({
  textAlign: "center",
  fontSize: "24px",
  fontWeight: 600,
  marginTop: "32px",
  marginBottom: "20px",
  color: "#333333",
});

const gridSx: SxProps<Theme> = {
  justifyContent: "center",
};

const cardSx: SxProps<Theme> = (theme) => ({
  height: "100%",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
  backgroundColor: "#FFFFFF",
});

const cardContentSx: SxProps<Theme> = {
  padding: "32px",
  textAlign: "center",
};

const cardTitleSx: SxProps<Theme> = (theme) => ({
  fontSize: "24px",
  fontWeight: 600,
  marginBottom: "16px",
  color: "#E74C3C",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
});

const cardDescriptionSx: SxProps<Theme> = {
  fontSize: "16px",
  lineHeight: 1.6,
  color: "#666666",
  textAlign: "left",
};

const subCardSx: SxProps<Theme> = (theme) => ({
  height: "100%",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
  borderRadius: "8px",
  backgroundColor: "#FFFFFF",
});

const subCardContentSx: SxProps<Theme> = {
  padding: "24px",
  textAlign: "center",
};

const subCardTitleSx: SxProps<Theme> = (theme) => ({
  fontSize: "18px",
  fontWeight: 600,
  marginBottom: "12px",
  color: "#E74C3C",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
});

const subCardDescriptionSx: SxProps<Theme> = {
  fontSize: "14px",
  lineHeight: 1.5,
  color: "#666666",
  textAlign: "left",
};

const iconSx: SxProps<Theme> = {
  fontSize: "32px",
  color: "#E74C3C",
};

const subIconSx: SxProps<Theme> = {
  fontSize: "24px",
  color: "#E74C3C",
};
